import type { Project, Unit, Warranties } from '@alrimal/contracts';
import { useLocale } from '../LocaleContext.tsx';
import { SeoShell } from './SeoShell.tsx';
import { LeadForm } from './LeadForm.tsx';

/**
 * No WebGL 2, or the engine failed to start.
 *
 * The buyer still gets the whole project and can still ask for the price — the
 * model was the presentation, not the product. This path is also what an old
 * in-app browser inside a messaging app sees, which is a meaningful share of
 * the traffic a WhatsApp-forwarded link produces.
 */
export function Fallback({
  project,
  units,
  warranties,
  reason,
}: {
  project: Project;
  units: readonly Unit[];
  warranties: Warranties;
  reason?: string;
}) {
  const { t, locale } = useLocale();

  return (
    <div className="fallback" id="main">
      <div className="notice">
        <div>
          <strong>{t('fallback.title')}</strong>
          <p>{t('fallback.body')}</p>
          {reason ? <p className="ltr">{reason}</p> : null}
        </div>
      </div>

      <SeoShell
        project={project}
        units={units}
        warranties={warranties}
        locale={locale}
      />

      <LeadForm
        units={units}
        selected={null}
        contactPhone={project.contact.phone}
        whatsappPhone={project.contact.whatsapp ?? null}
        source="fallback"
      />
    </div>
  );
}
